import { useEffect } from "react"
import { useContextSelector } from "use-context-selector"

import { useRequest } from "domain/core/hooks/useRequest"
import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"

import { TApiWebhookEventsRes } from "../types"

export const useInitWebhookEvents = (): void => {
  const update = useContextSelector(
    GlobalConfigContext,
    globalConfigSelectors.update
  )

  const { data, error }: TApiWebhookEventsRes = useRequest({
    url: "/v1/webhooks/events",
    sendOnStart: true,
  })

  useEffect(() => {
    if (!data) return

    update({
      webhookEvents: { data, error: null },
    })
  }, [data])

  useEffect(() => {
    if (!error) return

    update({
      webhookEvents: { data: {}, error },
    })
  }, [error])
}
